const APPCONFIG = appConfig
try {
  window.addEventListener('load', function () {
    // document.getElementsByTagName('title')[0].innerHTML = APPCONFIG.title
  }, false)
} catch (e) {
  console.log(e)
}
const base = {
  padLeftZero (str) {
    return ('00' + str).substr(str.length)
  },
  lotterySildeOption () {
    return APPCONFIG.lotterySilde
  },
  formatDate (time, fmt) {
    var date = new Date(time)
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str))
      }
    }
    return fmt
  },
  browser (iosfn, anfn, pcfn, _this) {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      iosfn && iosfn()
    } else if (/(Android)/i.test(navigator.userAgent)) {
      anfn && anfn()
    } else {
      pcfn && pcfn(_this)
    }
  },
  httpPosts (_this, url, data, success, fail) {
    let that = this
    _this.$http.post(url, data, {emulateJSON: true}).then(function (res) {
      if (res.body === -1) {
        _this.$router.push({path: '/login'})
        return
      }
      let result = res.body
      typeof result === 'string' && (result = eval('(' + result + ')'))
      success.call(this, result)
    }, function (res) {
      fail.call(this, res)
    })
    return _this
  },
  httpPost (_this, url, fn) {
    let that = this
    _this.$http.post(url).then(function (res) {
      if (res.body === -1) {
        _this.$router.push({path: '/login'})
        return
      }
      var result
      if (typeof res.body === 'string') {
        result = eval('(' + res.body + ')')
      } else {
        result = res.body
      }
      try {
        that && (result.that = that)
      } catch (e) {
        console.log(e)
      }
      fn.call(this, result)
    })
    return _this
  },
  storage () {
    return {
      set (name, value) {
        localStorage.setItem(name, value)
        return true
      },
      get (name) {
        let item = localStorage.getItem(name)
        return item
      },
      clear () {
        localStorage.clear()
      }
    }
  },
  lotteryarr: [],
  lotteryNum: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  lotteryName: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'P', 'S', 'W', 'Y', 'Z'],
  lotteryinit (lotteryarr) {
    let _this = this
    let arr = this.lotteryNum.concat(this.lotteryName)
    if (lotteryarr) {
      lotteryarr.forEach(function (item) {
        _this.lotteryarr.push(item.showName)
      })
    }
    return {
      getName (min, max) {
        let name = _this.randomWord(true, min, max, arr)
        let str = name[0]
        for (let i = 1; i < name.length - 2; i++) {
          str += '*'
        }
        str += name[name.length - 1]
        return str
      },
      getNum (min, max) {
        return parseInt(_this.randomWord(true, min, max, _this.lotteryNum).toString())
      },
      getLottery () {
        return _this.randomWord(false, 1, null, _this.lotteryarr)
      }
    }
  },
  randomWord (randomFlag, min, max, arr) {
    let str = ''
    let range = min
    let pos = null
    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min
    }
    for (let i = 0; i < range; i++) {
      pos = Math.round(Math.random() * (arr.length - 1))
      str += arr[pos]
    }
    return str
  },
  random (randomFlag, min, max) {
    let str = ''
    let range = min
    let pos = null
    let arr = this.lotteryNum.concat(this.lotteryName)
    // 随机产生
    if (randomFlag) {
      range = Math.round(Math.random() * (max - min)) + min
    }
    for (let i = 0; i < range; i++) {
      pos = Math.round(Math.random() * (arr.length - 1))
      str += arr[pos]
    }
    return str
  },
  LoginStatus () {
    return {
      get (_this, name) {
        return _this.$store.state[name]
      },
      set (_this, keys, value) {
        return _this.$store.commit(keys, value)
      }
    }
  },
  indexof (str, value) {
    return str.indexOf(value) === -1
  },
  doMove (e, c, d) {
    var g = 0
    var b = 0
    var f = null
    for (let a in c) {
      if (a === 'opacity') {
        g = parseInt(parseFloat(this.getStyle(e, a)) * 100)
      } else {
        g = parseInt(this.getStyle(e, a))
      }
      f = (c[a] - g) / 8
      f = f > 0 ? Math.ceil(f) : Math.floor(f)
      if (g !== c[a]) {
        b++
        if (a === 'opacity') {
          e.style.filter = 'alpha(opacity:' + (g + f) + ')'
          e.style.opacity = (g + f) / 100
        } else {
          e.style[a] = g + f + 'px'
        }
      }
    }
    b.toString() === '0' && clearInterval(e.timer) && d && d()
  },
  move (c, a, f, t) {
    t = t || 40
    clearInterval(c.timer)
    let _this = this
    c.timer = setInterval(function () {
      _this.doMove(c, a, f)
    }, t)
  },
  getStyle (b, a) {
    try {
      if (b.currentStyle) {
        return b.currentStyle[a]
      }
      return getComputedStyle(b, false)[a]
    } catch (err) {
      this.showerror(err)
      return false
    }
  },
  config () {
    return APPCONFIG
  },
  unique (arr) {
    let ret = []
    let len = arr.length
    let tmp = {}
    for (let i = 0; i < len; i++) {
      if (!tmp[arr[i]]) {
        tmp[arr[i]] = 1
        ret.push(arr[i])
      }
    }
    return ret
  },
  Promptfn () {
    return function (option) {
      new Prompt(option)
    }
  }
}

class Prompt {
  constructor (option) {
    let dom = document.getElementById('caverling_alert')
    if (dom) {
      dom.parentNode.removeChild(dom)
    }
    this.createDiv = document.createElement('div')
    this.createDiv.id = 'caverling_alert'
    this.timer = null
    this.option = option
    let {time = 2000} = option
    this.time = time
    this.init()
  }

  init () {
    let {message = '', note = ''} = this.option
    this.createDiv.innerHTML =
      `   <div class="alert_mask close-btn"></div>
                <div class='alert_content'>
                    <div class='jBox-title'>
                        <div class="left">
                            提示：<span class='title-sm'></span>
                        </div>
                        <div class='close-btn'><i class="icon">&#xe60b;</i></div>
                    </div>
                    <div class='jBox-content'>
                        ${message} <br />${note}
                    </div>
                </div>`
    this.bindEvent()
  }

  // 绑定事件
  bindEvent () {
    document.body.appendChild(this.createDiv)
    setTimeout(() => {
      this.createDiv.style.opacity = 1
      if (this.option.autoClose) {
        this.timer = setTimeout(() => {
          this.closeCreateDiv()
        }, this.time)
      }
      let maskArr = this.createDiv.getElementsByClassName('close-btn')
      for (let i = 0; i < maskArr.length; i++) {
        maskArr[i].onclick = function () {
          this.closeCreateDiv()
        }.bind(this)
      }
    }, 15)
  }

  // 关闭窗口
  closeCreateDiv () {
    clearTimeout(this.timer)
    this.createDiv.style.opacity = 0
    setTimeout(() => {
      this.createDiv.parentNode.removeChild(this.createDiv)
    }, 300)
  }
}
export default base



// WEBPACK FOOTER //
// src/js/pubilc.js